<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved. 
 Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<app-manual-tasks-list
  [tasks]="tasks$ | async"
  [scenario]="scenario$ | async"
></app-manual-tasks-list>
